import { render } from "./DashboardCaseCountGraph.vue?vue&type=template&id=48886e5c&scoped=true"
import script from "./DashboardCaseCountGraph.vue?vue&type=script&lang=js"
export * from "./DashboardCaseCountGraph.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-48886e5c"

export default script